// extracted by mini-css-extract-plugin
module.exports = {"currencyInfo":"_7d684f6","convertedAmount":"_b27abe4","avatar":"_7b18c48"};